module.exports = __webpack_public_path__ + "media/app/assets/specializations/warrior/arms-981b4c4824ba3d810944b17f673a1979.png";